<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Instrument Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <h3>Instrument Analyses</h3>
    <b-alert show variant="info">
      <p class="mb-0">
        Use the checkboxes below to define the set of analyses which can be
        performed by this instrument.
      </p>
    </b-alert>
    <b-tabs
      class="animated fadeIn"
      content-class="mt-3"
      v-if="sample_type_collection"
    >
      <template v-for="(sample_type, index) in sample_type_collection.models">
        <instrument-form-analysis-cardstack-card
          :key="index"
          :sample_type="sample_type"
          :instrument="instrument"
          :instrument_tests="instrument_tests"
          @instrumentAnalysisClick="instrumentAnalysisClick"
        />
      </template>
    </b-tabs>
  </div>
</template>

<script>
import InstrumentFormAnalysisCardstackCard from "@/components/lab/instrument/form/InstrumentFormAnalysisCardstackCard";
import InstrumentModel from "@/models/lab/InstrumentModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "InstrumentFormAnalysisCardstack",
  props: {
    instrument: {
      type: Object,
      default: () => new InstrumentModel()
    },
    instrument_tests: {
      type: Array,
      default: () => []
    }
  },
  components: {
    InstrumentFormAnalysisCardstackCard
  },
  data() {
    return {
      loading: true,
      sample_type_collection: null
    };
  },
  methods: {
    instrumentAnalysisClick(state) {
      return this.$emit("instrumentAnalysisClick", state);
    }
  },
  async created() {
    this.loading = true;

    this.sample_type_collection = await getCollection({
      collection_type: "sample_type",
      limit: "all",
      message: this.$bvToast
    });
    this.sample_type_collection.add(SampleTypeModel.initGeneralModel());

    this.loading = false;
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
